export default __webpack_public_path__ + "static/media/ic_gmx_24.81ffddca.svg";